import { useContext } from 'react'
import { StoreContext } from '../post-its/store'

export default () => useContext(StoreContext)
